export function getBuildingsIndicators(buildings, oldIndicators = []) {
  if (!buildings || Object.keys(buildings).length == 0) {
    return null
  }

  let indicators = {}
  let oldValues = {}
  Object.values(buildings)
    .filter((building) => building.type != 'mine' && building.type != 'spaceship')
    .map((building) => {
      let type = building.type
      let oldKey = oldIndicators.findIndex((ind) => ind.id == type)
      if (!indicators[type]) {
        indicators[type] = 0
      }
      indicators[type] += building.production * building.multiplier
      oldValues[type] = oldKey >= 0 ? oldIndicators[oldKey].value : 0
    })

  Object.keys(indicators).map((key) => (indicators[key] = indicators[key] + oldValues[key]))

  return indicators
}

export function UCFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getRandomIndexPool(array, maxAmount) {
  let result = []
  let random = Math.floor(Math.random() * array.length)

  while (result.length != maxAmount) {
    if (!result.includes(random)) {
      result.push(random)
    } else {
      random = Math.floor(Math.random() * array.length)
    }
  }

  return result
}

export function getMinStat(indicators) {
  let buildingList = { home: 0, water: 0, food: 0, energy: 0, oxygen: 0 }
  let minValue = null
  for (let key in indicators) {
    if (indicators.hasOwnProperty(key)) {
      if (buildingList[key] == 0) {
        if (minValue == null || indicators[key] < minValue) {
          minValue = indicators[key]
        }
      }
    }
  }
  return minValue
}

export function getUserSettlers(indicators) {
  let maxSettlersToCome = indicators.happiness || 0
  let minStat = getMinStat(indicators)
  let settlers = 0
  if (minStat < maxSettlersToCome) {
    settlers = minStat || 0
  } else {
    if (maxSettlersToCome + (indicators.settlers || 0) < minStat) {
      settlers += maxSettlersToCome
    } else {
      settlers = maxSettlersToCome
    }
  }
  return settlers
}

export function checkInRange(min, max, value) {
  //MAX NOT INCLUDED
  return value >= min && value < max
}

export function calculateCityLevel(numberOfBuildings, actualLevel) {
  if (numberOfBuildings < 4) {
    return 1
  } else if (checkInRange(4, 11, numberOfBuildings)) {
    return 2
  } else if (checkInRange(11, 16, numberOfBuildings)) {
    return 3
  } else if (checkInRange(16, 21, numberOfBuildings)) {
    return 4
  } else if (checkInRange(21, 26, numberOfBuildings)) {
    return 5
  } else if (checkInRange(26, 31, numberOfBuildings)) {
    return 6
  } else if (checkInRange(31, 36, numberOfBuildings)) {
    return 7
  } else if (checkInRange(36, 41, numberOfBuildings)) {
    return 8
  } else if (checkInRange(41, 46, numberOfBuildings)) {
    return 9
  } else if (numberOfBuildings >= 46) {
    return 10
  } else {
    return actualLevel
  }
}
